(function () {
  'use strict';

  var FREE_SHIPPING = 7500; // £75 in pence

  function fmt(cents) {
    return '\u00a3' + (cents / 100).toFixed(2);
  }

  function esc(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  var drawer   = document.getElementById('rd-cart-drawer');
  var overlay  = document.getElementById('rd-cart-overlay');
  var closeBtn = document.getElementById('rd-cdrawer-close');
  var countEl  = document.getElementById('rd-cdrawer-count');
  var shipEl   = document.getElementById('rd-cdrawer-shipping');
  var bodyEl   = document.getElementById('rd-cdrawer-body');
  var footEl   = document.getElementById('rd-cdrawer-foot');

  // ── Open / close ──
  function openDrawer() {
    drawer.classList.add('rd-cdrawer--open');
    overlay.classList.add('rd-cdrawer__overlay--open');
    drawer.setAttribute('aria-hidden', 'false');
    drawer.removeAttribute('inert');
    document.body.style.overflow = 'hidden';
    bodyEl.innerHTML = '<div class="rd-cdrawer__loading">Loading&hellip;</div>';
    fetchCart().then(render);
  }

  function closeDrawer() {
    drawer.classList.remove('rd-cdrawer--open');
    overlay.classList.remove('rd-cdrawer__overlay--open');
    drawer.setAttribute('aria-hidden', 'true');
    drawer.setAttribute('inert', '');
    document.body.style.overflow = '';
  }

  // ── Fetch ──
  function fetchCart() {
    return fetch('/cart.js').then(function (r) { return r.json(); });
  }

  function changeItem(key, qty) {
    bodyEl.innerHTML = '<div class="rd-cdrawer__loading">Updating&hellip;</div>';
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
      .then(function (r) { return r.json().then(function (b) { return { ok: r.ok, body: b }; }); })
      .then(function (res) {
        // If Shopify rejected the change (e.g. over-inventory), response is an
        // error object with no item_count/items. Re-fetch the real cart state
        // rather than rendering the error object (which would produce
        // "undefined items" / "£NaN away" / empty drawer).
        if (!res.ok || typeof res.body.item_count !== 'number' || !Array.isArray(res.body.items)) {
          var errMsg = (res.body && res.body.description) || 'Quantity unavailable';
          return fetchCart().then(function (cart) {
            render(cart);
            syncBadge(cart.item_count);
            // Flash a transient error above the items
            var errEl = document.createElement('div');
            errEl.className = 'rd-cdrawer__error';
            errEl.textContent = errMsg;
            errEl.style.cssText = 'padding:0.75rem 2rem;margin:0 0 0.25rem;color:#b00;font-size:0.7rem;font-weight:700;letter-spacing:0.05em;text-transform:uppercase;';
            bodyEl.insertAdjacentElement('afterbegin', errEl);
            setTimeout(function () { if (errEl.parentNode) errEl.remove(); }, 3500);
          });
        }
        render(res.body);
        syncBadge(res.body.item_count);
      })
      .catch(function () {
        // Network / parse error — fall back to fresh cart fetch
        fetchCart().then(function (cart) { render(cart); syncBadge(cart.item_count); });
      });
  }

  // ── Badge sync ──
  function syncBadge(count) {
    var badge = document.getElementById('rd-cart-badge');
    if (!badge) return;
    badge.textContent = count;
    badge.style.display = count > 0 ? 'flex' : 'none';
    var btn = document.getElementById('rd-cart-btn');
    if (btn) btn.setAttribute('aria-label', 'Cart (' + count + ' items)');
  }

  // ── Render shipping ──
  function renderShip(total) {
    var pct, rem, html;
    if (total >= FREE_SHIPPING) {
      html = '<div class="rd-cdrawer__ship-meta">'
        + '<span class="rd-cdrawer__ship-label">Free Shipping</span>'
        + '<span class="rd-cdrawer__ship-remaining">Unlocked \u2014 enjoy free UK delivery</span>'
        + '</div>'
        + '<div class="rd-cdrawer__ship-track"><div class="rd-cdrawer__ship-fill" style="width:100%"></div></div>';
    } else {
      rem = FREE_SHIPPING - total;
      pct = Math.round((total / FREE_SHIPPING) * 100);
      html = '<div class="rd-cdrawer__ship-meta">'
        + '<span class="rd-cdrawer__ship-label">Free Shipping</span>'
        + '<span class="rd-cdrawer__ship-remaining">' + fmt(rem) + ' away</span>'
        + '</div>'
        + '<div class="rd-cdrawer__ship-track"><div class="rd-cdrawer__ship-fill" style="width:' + pct + '%"></div></div>';
    }
    shipEl.innerHTML = html;
  }

  // ── Render items ──
  function renderItems(items) {
    if (!items || items.length === 0) {
      bodyEl.innerHTML = '<div class="rd-cdrawer__empty">'
        + '<p class="rd-cdrawer__empty-title">Your rotation is empty</p>'
        + '<p class="rd-cdrawer__empty-sub">Nothing in the bag yet</p>'
        + '<a href="/collections/all" class="rd-cdrawer__empty-link">Browse the range &rarr;</a>'
        + '</div>';
      return;
    }

    var html = '';
    for (var i = 0; i < items.length; i++) {
      var it = items[i];
      var variant = (it.variant_title && it.variant_title !== 'Default Title') ? it.variant_title : '';
      var imgUrl = '';
      if (it.featured_image && it.featured_image.url) {
        imgUrl = it.featured_image.url.replace(/(\.(jpg|jpeg|png|gif|webp))(\?.*)?$/, '_240x320$1');
      }

      html += '<div class="rd-cdrawer__item">';
      html += '<div class="rd-cdrawer__img-wrap">';
      if (imgUrl) {
        html += '<img src="' + esc(imgUrl) + '" alt="' + esc(it.product_title) + '" class="rd-cdrawer__img" loading="lazy" width="96" height="128">';
      } else {
        html += '<div class="rd-cdrawer__img" style="background:#e9e8e7;width:100%;height:100%;"></div>';
      }
      html += '</div>';

      html += '<div class="rd-cdrawer__item-info">';
      html += '<div class="rd-cdrawer__item-top">';
      html += '<h3 class="rd-cdrawer__item-name">' + esc(it.product_title) + '</h3>';
      html += '<span class="rd-cdrawer__item-price">' + fmt(it.line_price) + '</span>';
      html += '</div>';
      if (variant) {
        html += '<p class="rd-cdrawer__item-variant">' + esc(variant) + '</p>';
      }
      html += '<div class="rd-cdrawer__item-actions">';
      html += '<div class="rd-cdrawer__qty">';
      html += '<button class="rd-cdrawer__qty-btn" data-key="' + esc(it.key) + '" data-qty="' + (it.quantity - 1) + '" aria-label="Decrease"' + (it.quantity <= 1 ? ' disabled' : '') + '>\u2212</button>';
      html += '<span class="rd-cdrawer__qty-num">' + String(it.quantity).padStart(2, '0') + '</span>';
      html += '<button class="rd-cdrawer__qty-btn" data-key="' + esc(it.key) + '" data-qty="' + (it.quantity + 1) + '" aria-label="Increase">+</button>';
      html += '</div>';
      html += '<button class="rd-cdrawer__remove" data-key="' + esc(it.key) + '" data-qty="0" aria-label="Remove">Remove</button>';
      html += '</div>';
      html += '</div>';
      html += '</div>';
    }

    bodyEl.innerHTML = html;

    bodyEl.querySelectorAll('[data-key]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        changeItem(this.getAttribute('data-key'), parseInt(this.getAttribute('data-qty'), 10));
      });
    });
  }

  // ── Render footer ──
  function renderFoot(cart) {
    if (!cart.items || cart.items.length === 0) {
      footEl.innerHTML = '';
      return;
    }
    var pts = Math.floor(cart.total_price / 100);
    var ptsNote = pts > 0
      ? '<p class="rd-cdrawer__pts-note"><svg width="10" height="10" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M12 2l2.4 7.4H22l-6.2 4.5 2.4 7.4L12 17l-6.2 4.3 2.4-7.4L2 9.4h7.6z"/></svg> EARN ' + pts + ' PTS ON THIS ORDER</p>'
      : '';
    footEl.innerHTML = '<div class="rd-cdrawer__totals">'
      + '<div class="rd-cdrawer__total-row">'
      + '<span class="rd-cdrawer__total-label">Subtotal</span>'
      + '<span class="rd-cdrawer__total-value">' + fmt(cart.items_subtotal_price) + '</span>'
      + '</div>'
      + '<div class="rd-cdrawer__total-row">'
      + '<span class="rd-cdrawer__total-label">Shipping</span>'
      + '<span class="rd-cdrawer__total-label">Calculated at checkout</span>'
      + '</div>'
      + '<div class="rd-cdrawer__total-row rd-cdrawer__total-row--grand">'
      + '<span class="rd-cdrawer__total-label">Total</span>'
      + '<span class="rd-cdrawer__total-value">' + fmt(cart.total_price) + '</span>'
      + '</div>'
      + '</div>'
      + ptsNote
      + '<a href="/checkout" class="rd-cdrawer__checkout">Secure Checkout</a>'
      + '<span class="rd-cdrawer__klarna">Klarna &amp; Afterpay available at step 2</span>';

    // Inject express-checkout (Apple Pay / Shop Pay / Google Pay) above Secure Checkout.
    // Source is server-side Liquid in #rd-cdrawer-express-source so Shopify's
    // payment_button tokens stay valid. We clone the markup so any Shopify
    // wallet-button web component re-initializes on the new node.
    try {
      var src = document.getElementById('rd-cdrawer-express-source');
      var checkout = footEl.querySelector('.rd-cdrawer__checkout');
      if (src && checkout && src.innerHTML.trim()) {
        var wrap = document.createElement('div');
        wrap.className = 'rd-cdrawer__express';
        wrap.innerHTML = src.innerHTML;
        checkout.parentNode.insertBefore(wrap, checkout);
      }
    } catch (e) { /* non-fatal — drawer still works without express */ }
  }

  // ── Main render ──
  function render(cart) {
    var n = cart.item_count;
    countEl.textContent = n + (n === 1 ? ' item' : ' items');
    renderShip(cart.total_price);
    renderItems(cart.items);
    renderFoot(cart);
    syncBadge(n);
  }

  // ── Event wiring ──
  if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
  if (overlay)  overlay.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeDrawer();
  });

  // Cart button opens drawer
  document.addEventListener('click', function (e) {
    if (e.target.closest('#rd-cart-btn')) {
      e.preventDefault();
      openDrawer();
    }
  });

  // Intercept add-to-cart form submissions (capture phase)
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[action="/cart/add"]');
    if (!form) return;
    e.preventDefault();
    var fd = new FormData(form);
    // Show loading state on the ATC button
    var btn = form.querySelector('[name="add"]');
    var origText = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'ADDING...'; }
    fetch('/cart/add.js', { method: 'POST', body: fd })
      .then(function (r) { return r.json(); })
      .then(function () {
        if (btn) { btn.disabled = false; btn.textContent = origText; }
        openDrawer();
      })
      .catch(function () {
        if (btn) { btn.disabled = false; btn.textContent = origText; }
        form.submit();
      });
  }, true);

  // Init badge count on page load
  document.addEventListener('DOMContentLoaded', function () {
    fetchCart().then(function (cart) { syncBadge(cart.item_count); });
  });

  // Expose globally
  window.rdCartDrawer = { open: openDrawer, close: closeDrawer };
})();
